import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

type Props = {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const UNSAVED_CHANGES_MODAL_STYLES = {
    content: {
        width: "420px",
        padding: "0",
    },
};

export const UnsavedChangesModal = ({ isOpen, onCancel, onConfirm }: Props) => {
    const { translate } = useTranslate();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            customStyles={UNSAVED_CHANGES_MODAL_STYLES}
            data-automation="team-detail-unsaved-changes-modal"
        >
            <Modal.Header>
                <Modal.Title data-automation="team-detail-unsaved-changes-modal-title">
                    {translate("si.management.teams.detail.unsaved_changes.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[400]}
                    data-automation="team-detail-unsaved-changes-modal-body"
                >
                    {translate("si.management.teams.detail.unsaved_changes.body")}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    type="flatDark"
                    onClick={onCancel}
                    dataAutomation="team-detail-unsaved-changes-modal-cancel"
                >
                    {translate("si.management.teams.detail.unsaved_changes.cancel")}
                </Button>
                <Button
                    type="warning"
                    onClick={onConfirm}
                    dataAutomation="team-detail-unsaved-changes-modal-confirm"
                >
                    {translate("si.management.teams.detail.unsaved_changes.discard")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
